// extracted by mini-css-extract-plugin
export default {"card":"AuthorizeConsent_card__KNkY9","footerSection":"AuthorizeConsent_footerSection__y5EE+","footerLink":"AuthorizeConsent_footerLink__FvbhC"};